export default "__VITE_ASSET__faa89759__"